import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { ERRORS } from 'locales/locales'
import { useAppSelector } from '../app/hooks'

import DropdownAlert from 'components/dropdown-alert/DropdownAlert'
import { isFlagSetIn } from 'utils/helpers/isSetInFlags'
import { IRolePermissions, SettingsPermissions, TeamAndChannelPermissions, UserManagementPermissions } from 'types/role.types'

const ProtectedAdminRoute = ({ children }: { children: ReactNode }) => {
  const permissions = useAppSelector<IRolePermissions>((state) => state.auth.permissions)
  const { t } = useTranslation()
  const hasSettingsViewPermission = isFlagSetIn(
    [
      SettingsPermissions.VIEW_DASHBOARD,
      SettingsPermissions.VIEW_SYSTEM_SETTINGS,
      SettingsPermissions.VIEW_PASSWORD_SETTINGS,
      SettingsPermissions.VIEW_EMAIL_SETTINGS,
      SettingsPermissions.VIEW_LDAP_SETTINGS,
      SettingsPermissions.VIEW_ROLE_SETTINGS,
    ],
    permissions.settings,
  )

  const hasUserViewPermission = isFlagSetIn(
    [UserManagementPermissions.VIEW_USER_SETTINGS],
    permissions.userManagement,
  )

  const hasTeamsAndChannelsViewPermission = isFlagSetIn(
    [TeamAndChannelPermissions.VIEW_TEAM_SETTINGS, TeamAndChannelPermissions.VIEW_CHANNEL_SETTINGS],
    permissions.teamAndChannel,
  )
  const isAdmin =
    permissions.settings > 0 ||
    permissions.userManagement > 0 ||
    hasSettingsViewPermission ||
    hasUserViewPermission ||
    hasTeamsAndChannelsViewPermission

  if (!isAdmin) {
    DropdownAlert?.ref?.show({ isError: true, message: t(ERRORS.DONT_HAVE_ACCESS) })
    return <Navigate to="/news-feed" />
  }

  return <>{children}</>
}

export default ProtectedAdminRoute


